import React, { useEffect, useRef, useState } from 'react';
import { Button, Input } from 'antd';
import { Parser } from 'expr-eval';
import { combineEventsWithSameUniqueChar, isAdditionalPeriods } from '../../utils/event/common';

const formulaReg = /[a-zA-Z0-9-+.()*/]/g;

export const parser = new Parser({
  operators: {
    add: true,
    subtract: true,
    divide: true,
    multiply: true,
    comparison: false,
    concatenate: false,
    conditional: false,
    factorial: false,
    logical: false,
    power: false,
    remainder: false,
    sin: false,
    cos: false,
    tan: false,
    asin: false,
    acos: false,
    atan: false,
    sinh: false,
    cosh: false,
    tanh: false,
    asinh: false,
    acosh: false,
    atanh: false,
    sqrt: false,
    log: false,
    ln: false,
    lg: false,
    log10: false,
    abs: false,
    ceil: false,
    floor: false,
    round: false,
    trunc: false,
    exp: false,
    length: false,
    in: false,
  },
});

export const isValidFormula = (formula, result) => {
  try {
    const combinedEventsWithSameUniqueChar = combineEventsWithSameUniqueChar(result);

    const forbiddenSymbols = combinedEventsWithSameUniqueChar
      .flatMap((events) => {
        const isEventsWithAdditionalPeriods = isAdditionalPeriods(events);
        if (isEventsWithAdditionalPeriods) {
          return events.map(({ info }) => info.uniqueChar);
        }
        return null;
      })
      .filter((char) => !!char);

    const expr = parser.parse(formula);
    const uniqueChars = result.map((event) => event.info.uniqueChar);
    const dataVerification = expr.symbols().reduce((acc, elem, index) => {
      acc[elem] = index + 1;
      return acc;
    }, {});
    const isExistsForbiddenSymbols = expr.symbols().some((r) => forbiddenSymbols.includes(r));
    return (
      !isExistsForbiddenSymbols &&
      expr.symbols().every((r) => uniqueChars.includes(r)) &&
      Number.isFinite(expr.evaluate(dataVerification))
    );
  } catch (e) {
    return false;
  }
};

export const isValidSymbols = (formula) => {
  let matches = formula.match(formulaReg);
  matches = matches || [];

  return matches.length === formula.length;
};

const EventFormula = ({ enterFormula, options, showFormula, result, className = '' }) => {
  const { enteredFormula } = options;
  // используется для автофокуса.
  const formulaInput = useRef(null);
  useEffect(() => {
    formulaInput.current.focus();
  }, [showFormula]);

  // ввод формулы и ее валидация.
  const [formula, setFormula] = useState('');
  const [isValidInput, setValidInput] = useState(true);

  useEffect(() => {
    setFormula(enteredFormula);
  }, [enteredFormula]);

  const onChange = (value) => {
    const isValid =
      (isValidSymbols(value) && isValidFormula(value.toUpperCase(), result)) || value === '';
    setValidInput(isValid);
    setFormula(value.toUpperCase());
  };

  return (
    <div className={className} style={{ display: 'flex', alignItems: 'left' }}>
      <Input
        className={isValidInput ? '' : 'not-valid'}
        placeholder="Type formula"
        value={formula}
        onChange={(e) => onChange(e.target.value)}
        style={{
          marginRight: '2px',
        }}
        ref={formulaInput}
      />
      <Button
        style={{ width: '120px' }}
        onClick={() => enterFormula(formula)}
        disabled={!isValidInput || !formula}
        type="primary"
      >
        Apply
      </Button>
    </div>
  );
};

export default EventFormula;
